import SetPassword from './container';

export default SetPassword;
